/**
 * T107 — Master › Rekening Resmi Cabang: aturan isian di layar (MURNI, tanpa React).
 *
 * Penjaga SUNGGUHAN ada di server (`backend/services/rekening_resmi.py`): nomor dibersihkan dari spasi, tanda
 * hubung, dan titik, lalu wajib 5–20 angka. Berkas ini hanya supaya Owner tahu salahnya SEBELUM menekan Simpan —
 * aturannya sama persis dengan server.
 */
export const NOMOR_MIN = 5;
export const NOMOR_MAKS = 20;

/** "51-37 399.399" → "5137399399" (pemisah dibuang, huruf TIDAK dibuang). */
export function bersihkanNomor(nomor) {
  return String(nomor ?? "").replace(/[\s.-]/g, "");
}

/** Pesan salah untuk isian nomor, atau null bila sah. */
export function salahNomor(nomor) {
  const b = bersihkanNomor(nomor);
  if (!b) return "Nomor rekening wajib diisi.";
  if (!/^[0-9]+$/.test(b)) return "Nomor rekening hanya boleh berisi angka (spasi dan tanda hubung boleh, huruf tidak).";
  if (b.length < NOMOR_MIN || b.length > NOMOR_MAKS) return `Nomor rekening harus ${NOMOR_MIN} sampai ${NOMOR_MAKS} angka.`;
  return null;
}

/** Pesan salah untuk seluruh formulir, atau null bila sah. `nomorWajib` false saat mengubah (kosong = nomor tetap). */
export function salahFormulir({ bank, nomor, atasNama }, { nomorWajib = true } = {}) {
  if (String(bank ?? "").trim().length < 2) return "Nama bank wajib diisi.";
  if (String(atasNama ?? "").trim().length < 2) return "Nama pemilik rekening (atas nama) wajib diisi.";
  if (nomorWajib || bersihkanNomor(nomor)) return salahNomor(nomor);
  return null;
}
